import { useState } from 'react';
import { Mail, Copy, Check } from 'lucide-react';

interface EmailRowProps {
  email: string;
}

export function EmailRow({ email }: EmailRowProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (e) {
      // noop
    }
  };

  return (
    <div className="mt-auto pt-6">
      <div className="flex items-center justify-between">
        <a
          data-testid="cta-email"
          href={`mailto:${email}`}
          className="inline-flex items-center gap-2 text-white/80 hover:text-white group"
        >
          <Mail className="h-4 w-4" />
          <span className="font-mono text-sm md:text-base tracking-tight">{email}</span>
        </a>
        <button
          onClick={copy}
          aria-label={copied ? 'Copied' : 'Copy email'}
          className="rounded-full border border-white/10 bg-white/5 px-2.5 py-1.5 text-xs text-white/70 hover:bg-white/10"
        >
          {copied ? (
            <span className="inline-flex items-center gap-1"><Check className="h-3.5 w-3.5" /> Copied</span>
          ) : (
            <span className="inline-flex items-center gap-1"><Copy className="h-3.5 w-3.5" /> Copy</span>
          )}
        </button>
      </div>
    </div>
  );
}
